/* ══════════════════════════════════════════════════════════════
   LORGAR CLASS LOADOUT
   Tab switching, live totals, one-click add-all.
   Load AFTER brutech-partners.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); }
      catch (e) { /* fall through */ }
    }
    var v = (cents / 100).toFixed(2);
    return 'R' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function initWrap(wrap) {
    if (wrap.dataset.clReady) return;
    wrap.dataset.clReady = '1';

    var tabs   = Array.prototype.slice.call(wrap.querySelectorAll('[data-cl-tab]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[data-cl-panel]'));
    if (!tabs.length || !panels.length) return;

    /* ── read each class's data once ── */
    var classes = {};
    panels.forEach(function (panel) {
      var idx = panel.getAttribute('data-cl-panel');
      var el  = panel.querySelector('[data-cl-data]');
      if (!el) return;
      try { classes[idx] = JSON.parse(el.textContent); }
      catch (e) { console.warn('[Brutech] Class loadout JSON:', e); }
    });

    /* ── totals ── */
    function paint(panel, idx) {
      var data = classes[idx];
      if (!data) return;

      var items = (data.items || []).filter(function (i) { return i && i.id; });
      var gross = items.reduce(function (sum, i) { return sum + (i.price || 0); }, 0);
      var pct   = parseFloat(data.discount) || 0;
      var net   = pct > 0 ? Math.round(gross * (100 - pct) / 100) : gross;

      var countEl = panel.querySelector('[data-cl-count]');
      if (countEl) {
        countEl.textContent = items.length + (items.length === 1 ? ' ITEM' : ' ITEMS')
                            + (pct > 0 ? '  ·  SAVE ' + pct + '%' : '');
      }

      var totalEl = panel.querySelector('[data-cl-total]');
      if (totalEl) totalEl.textContent = money(net);

      var wasEl = panel.querySelector('[data-cl-was]');
      if (wasEl) {
        if (pct > 0) { wasEl.textContent = money(gross); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }

      /* nothing purchasable, disable rather than fail at cart */
      var live = items.filter(function (i) { return i.available; });
      var btn = panel.querySelector('[data-cl-add]');
      if (btn && !live.length) {
        btn.disabled = true;
        btn.textContent = 'OUT OF STOCK';
      }
    }

    /* ── tab switching ── */
    function show(idx) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cl-tab') === String(idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-cl-panel') === String(idx);
        p.hidden = !on;
        if (on) p.classList.add('is-active'); else p.classList.remove('is-active');
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-cl-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var i = tabs.indexOf(t);
        var n = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if (n < 0) n = tabs.length - 1;
        if (n >= tabs.length) n = 0;
        tabs[n].focus();
        show(tabs[n].getAttribute('data-cl-tab'));
      });
    });

    /* ── add all ── */
    panels.forEach(function (panel) {
      var idx = panel.getAttribute('data-cl-panel');
      paint(panel, idx);

      var btn = panel.querySelector('[data-cl-add]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var data = classes[idx];
        if (!data) return;

        var ids = (data.items || [])
          .filter(function (i) { return i && i.id && i.available; })
          .map(function (i) { return { id: i.id, quantity: 1 }; });

        if (!ids.length) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'EQUIPPING…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          return r.json();
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (e) {
          console.warn('[Brutech] Class add:', e);
          btn.disabled = false;
          btn.textContent = original;
        });
      });
    });

    /* open the first class */
    show(tabs[0].getAttribute('data-cl-tab'));
  }

  function init() {
    try {
      document.querySelectorAll('[data-cl-wrap]').forEach(initWrap);
    } catch (e) {
      console.warn('[Brutech] Class loadout:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
})();
